export const stripCodeFences = (text: string): string => {
	const trimmed = text.trim();

	if (trimmed.startsWith("```") && trimmed.endsWith("```")) {
		const lines = trimmed.split("\n");
		lines.shift();
		lines.pop();
		return lines.join("\n");
	}

	const lines = text.split("\n");

	const startIndex = lines.findIndex((line) => line.trim().startsWith("```markdown"));

	if (startIndex === -1) {
		return text;
	}

	let endIndex = -1;
	for (let i = lines.length - 1; i > startIndex; i--) {
		if (lines[i].trim() === "```") {
			endIndex = i;
			break;
		}
	}

	if (endIndex === -1) {
		return text;
	}

	const result = [
		...lines.slice(0, startIndex),
		...lines.slice(startIndex + 1, endIndex),
		...lines.slice(endIndex + 1),
	];

	return result.join("\n");
};
